import {Box, Button, styled, Tab, Tabs, Typography} from "@mui/material"
import React, {useContext, useEffect, useMemo, useState} from "react"
import {DataContext} from "../../../context/DataContextProvider"
import ProduktErgebnisEntry from "./ProduktErgebnis/ProduktErgebnisEntry"
import {toast} from "react-toastify"
import {ProduktSelect} from "./ergebnisselect/ergebnisSelect"
import {calculateMatchPercentage} from "../../../../anwendungskonfigurator/misc/utils"
import {useTheme} from "@mui/material"
import ValueWidget from "../../../../anwendungskonfigurator/content/widgets/ValueWidget"
import {widgetFromDomaintypeGenerator} from "../../../../anwendungskonfigurator/misc/widget-functions"
import { TabPanel } from './../../Container/Produktsuche/TabPanel';

const GridItem = styled(Box)(({theme}) => (theme.GridItem.VergleichGridItem))
const EmptyGridItem = styled(Box)(({theme}) => (theme.GridItem.EmptyGridItem))
const ProduktwahlButton = styled(Button)(({theme}) => (theme.UploadButton))
const handleClick = () => toast.info("Produkt gewählt")

const ProduktErgebnisWidget = () => {
    const theme = useTheme()
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const produktInfo = getDataFromPointer("/produktInfo")
    const produkte =
        produktInfo?.flatMap(produktgeber => produktgeber.produkte) ?? []
    const spartenMerkmale = getDataFromPointer("/sparteList") ?? []
    const filteredSpartenMerkmale = useMemo(() => spartenMerkmale.filter(sparte => sparte.kunde), [spartenMerkmale])
    const searchParameter = getDataFromPointer("/suche")
    const [activeTab, setActiveTab] = useState(0)
    const handleChange = (event, newValue) => {
        const newIndex = filteredSpartenMerkmale.findIndex(item => item.label === newValue)
        if (newIndex !== -1) {
            setActiveTab(newIndex)
        }
    }
    const [firstProdukt, setFirstProdukt] = React.useState({})
    const [secondProdukt, setSecondProdukt] = React.useState({})
    const [thirdProdukt, setThirdProdukt] = React.useState({})
    const currentMerkmale = useMemo(() => filteredSpartenMerkmale[activeTab]?.merkmale ?? [], [activeTab])

    const handleSelectFirstChange = (event) => {
        setFirstProdukt(event.target.value);
    };
    const handleSelectSecondChange = (event) => {
        setSecondProdukt(event.target.value);
    };
    const handleSelectThirdChange = (event) => {
        setThirdProdukt(event.target.value);
    };

    const labels = useMemo(() => [firstProdukt?.label, secondProdukt?.label, thirdProdukt?.label], [firstProdukt, secondProdukt, thirdProdukt])

    const barData = useMemo(() => [{
        labels: labels,
        data: [
            {
                value: calculateMatchPercentage(firstProdukt, searchParameter, currentMerkmale),
                label: firstProdukt?.label,
                backgroundColor: theme.palette.primary.main,
                stack: "erstesProdukt",
            },
            {
                value: calculateMatchPercentage(secondProdukt, searchParameter, currentMerkmale),
                label: secondProdukt?.label,
                backgroundColor: theme.palette.secondary.main,
                stack: "zweitesProdukt",
            },
            {
                value: calculateMatchPercentage(thirdProdukt, searchParameter, currentMerkmale),
                label: thirdProdukt?.label,
                backgroundColor: theme.palette.tertiary.main,
                stack: "drittesProdukt",
            },
        ]}], [firstProdukt, secondProdukt, thirdProdukt, currentMerkmale])

    useEffect(() => updateData(barData, "/detailAuswertungBarData"), [barData])


    return (
        <Box>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs onChange={handleChange} value={filteredSpartenMerkmale[activeTab]?.label || false}
                      aria-label="Produktergebnis tabs">
                    {filteredSpartenMerkmale.map((item, index) => (
                        <Tab
                            key={item.label || index}
                            label={item.label}
                            value={item.label}
                        />
                    ))}
                </Tabs>
            </Box>
            {filteredSpartenMerkmale.map(({label, merkmale, id}, index) => (
                <TabPanel key={label || index} value={activeTab} index={index}>
                    <Box display="grid" gridTemplateColumns="2fr 2fr 3fr 3fr 3fr" gap="5px">
                        <EmptyGridItem/>
                        <EmptyGridItem/>
                        <ProduktwahlButton onClick={handleClick} sx={{mr: 4, mb: 2}}>Produkt wählen</ProduktwahlButton>
                        <ProduktwahlButton onClick={handleClick} sx={{mr: 4, mb: 2}}>Produkt wählen</ProduktwahlButton>
                        <ProduktwahlButton onClick={handleClick} sx={{mr: 4, mb: 2}}>Produkt wählen</ProduktwahlButton>
                        <Typography variant="h2" p={1} pt={2}>
                            Merkmal
                        </Typography>
                        <Typography variant="h2" p={1} pt={2}>
                            Kundeninformation
                        </Typography>
                        <ProduktSelect id="first" value={firstProdukt} onChangeFunction={(selectedValue) => handleSelectFirstChange(selectedValue, merkmale)} produkte={produkte} sparteId={id}/>
                        <ProduktSelect id="second" value={secondProdukt} onChangeFunction={(selectedValue) => handleSelectSecondChange(selectedValue, merkmale)} produkte={produkte} sparteId={id}/>
                        <ProduktSelect id="third" value={thirdProdukt} onChangeFunction={(selectedValue) => handleSelectThirdChange(selectedValue, merkmale)} produkte={produkte} sparteId={id}/>
                        {merkmale.map(merkmal => [
                            <GridItem>
                                <Typography>{merkmal.label}</Typography>
                            </GridItem>,
                            <GridItem>
                                <ValueWidget widget={widgetFromDomaintypeGenerator(merkmal, `/suche/kunde/${merkmal.id}`)} value={getDataFromPointer(`/suche/kunde/${merkmal.id}`)}/>
                            </GridItem>,
                            <ProduktErgebnisEntry produkt={firstProdukt} merkmal={merkmal} searchParameter={searchParameter}/>,
                            <ProduktErgebnisEntry produkt={secondProdukt} merkmal={merkmal} searchParameter={searchParameter}/>,
                            <ProduktErgebnisEntry produkt={thirdProdukt} merkmal={merkmal} searchParameter={searchParameter}/>
                        ])}
                    </Box>
                </TabPanel>
            ))}
        </Box>
    )
}

export default ProduktErgebnisWidget
